module.exports = __webpack_public_path__ + "static/media/sb.2a57ea0c.svg";